var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1931_912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.62 17.5303C30.25 11.3003 24.34 7.53027 17.8 7.53027C11.26 7.53027 5.33997 11.3003 1.99997 17.5303L1.71997 18.0003L1.97997 18.4803C5.34997 24.7103 11.26 28.4803 17.8 28.4803C24.34 28.4803 30.26 24.7603 33.62 18.4803L33.88 18.0003L33.62 17.5303ZM17.8 26.4303C12.17 26.4303 6.99997 23.2903 3.99997 18.0003C6.99997 12.7103 12.17 9.57027 17.8 9.57027C23.43 9.57027 28.54 12.7203 31.59 18.0003C28.54 23.2903 23.42 26.4303 17.8 26.4303Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.09 24.8899C21.8787 24.8899 24.95 21.8186 24.95 18.0299C24.95 14.2412 21.8787 11.1699 18.09 11.1699C14.3013 11.1699 11.23 14.2412 11.23 18.0299C11.23 21.8186 14.3013 24.8899 18.09 24.8899Z",
    fill: "#00ADEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1931_912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eyeShow.d8c2f1b88cf4e9ddfa2722af571983c0.svg";
export { ForwardRef as ReactComponent };